<script>
  import { ShopboxHomeApp } from "@shopboxai/sb-home-app";
  import { useNavigate } from "svelte-navigator";
  import { userToken, currentUser } from "../stores";

  const navigate = useNavigate();
</script>

<ShopboxHomeApp user={JSON.stringify($userToken)} currentClient={$currentUser.fullClientId} on:redirect={(e) => navigate(e.detail)} />
